import React from "react";

export default function HeaderContent() {
    const [isOpen, setIsOpen] = React.useState(false);

  return (
  
       <div>
      {/* Inline CSS for Responsive Header & Drawer */}
      <style>
        {`
          .header {
            width: 95%;
            height: 60px;
            background-color: #f8f9fa;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 40px;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
            position: relative;
          }

          .title {
            color: #333;
            font-size: 22px;
            font-weight: 600;
            letter-spacing: 0.5px;
            margin: 0;
          }

          .menu {
            display: flex;
            gap: 30px;
            font-size: 18px;
            color: #333;
            cursor: pointer;
            font-weight: 500;
          }

          .menu span:hover {
            color: #007bff;
            transition: color 0.3s ease;
          }

          /* Hamburger Button (Right side) */
          .hamburger {
            display: none;
            flex-direction: column;
            cursor: pointer;
            gap: 5px;
          }

          .bar {
            width: 25px;
            height: 3px;
            background-color: #333;
            border-radius: 2px;
            transition: 0.3s;
          }

          /* Drawer Menu (hidden by default) */
          .drawer {
            position: absolute;
            top: 60px;
            right: 0;
            width: 200px;
            background-color: #f8f9fa;
            box-shadow: -2px 0 10px rgba(0,0,0,0.1);
            padding: 15px 20px;
            display: flex;
            flex-direction: column;
            z-index: 10;
            animation: slideIn 0.3s ease;
          }

          @keyframes slideIn {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }

          .drawer span {
            margin: 12px 0;
            font-size: 18px;
            color: #333;
            cursor: pointer;
          }

          .drawer span:hover {
            color: #007bff;
          }

          /* Responsive Styles */
          @media (max-width: 618px) {
            .menu {
              display: none;
            }
            .hamburger {
              display: flex;
              right:10px
            }
          }
        `}
      </style>

      {/* Header Section */}
      <div className="header">
        {/* Left Side - Logo */}
        <h2 className="title">Despatch Dost</h2>

        {/* Desktop Menu */}
        <div className="menu">
          <span>Services</span>
          <a href="aboutus">About</a>
          <a href="contactus">Contact</a>
        </div>

        {/* Right Side Hamburger (Visible on Mobile) */}
        <div className="hamburger" onClick={() => setIsOpen(!isOpen)}>
          <div className="bar" />
          <div className="bar" />
          <div className="bar" />
        </div>

        {/* Drawer Menu (Mobile) */}
        {isOpen && (
          <div className="drawer">
            <span>Services</span>
            <span>About</span>
            <span>Contact</span>
          </div>
        )}
      </div>
    </div>

  )
}